import { useAuth } from 'hooks/useAuth';
import RewardsLogo from 'assets/RewardsLogo.svg';
import { ChevronDownFilled } from '@fluentui/react-icons';
import { useState, useMemo } from 'react';
import ReactPopover from 'components/Common/Popover';
import HeaderPopoverContent from 'components/Header/HeaderPopoverContent';

const OnboardingHeader = () => {
  const authContext = useAuth();
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  // Extract username from email or use full name
  const displayName = useMemo(() => {
    const name = authContext?.user?.name || '';
    return name.includes('@') ? name.split('@')[0] : name;
  }, [authContext?.user?.name]);

  return (
    <div className="fixed top-0 left-0 right-0 z-[40] bg-white border-b border-borderGrey flex-shrink-0 w-full h-[60px] md:h-[88px] flex items-center justify-between px-4 md:px-16">
      {/* Logo */}
      <img src={RewardsLogo} alt="Open Rewards" className="h-6 md:h-8" />

      {/* User Dropdown */}
      <div className="relative">
        <ReactPopover
          contentClass={'md:right-12 md:left-auto md:!min-w-[200px] md:!w-auto'}
          onClose={onClose}
          open={open}
          content={
            <HeaderPopoverContent authContext={authContext} setOpen={setOpen} onClose={onClose} />
          }
        >
          <div className="flex items-center gap-2 p-2 cursor-pointer" onClick={() => setOpen(true)}>
            <span className="text-sm font-poppins font-normal text-darkBlue">{displayName}</span>
            <ChevronDownFilled fontSize={20} className="w-5 h-5 text-darkBlue" />
          </div>
        </ReactPopover>
      </div>
    </div>
  );
};

export default OnboardingHeader;
